import ExpedienteCreateView from './views/ExpedienteCreateView.vue'
import ExpedienteEntryView from './views/ExpedienteEntryView.vue'
import ExpedienteCreateApelacionView from './views/ExpedienteCreateApelacionView.vue'
import ExpedienteCreateComiteView from './views/ExpedienteCreateComiteView.vue'
import ExpedienteCreateDescargoView from './views/ExpedienteCreateDescargoView.vue'
import ExpedienteCreateTribunalView from './views/ExpedienteCreateTribunalView.vue'
import ExpedienteCreateNotificationView from './views/ExpedienteCreateNotificationView.vue'
import ExpedienteList from './views/ExpedienteList.vue'
import ExpedienteCreate from './views/ExpedienteCreate.vue'
import ExpedienteDetailView from './views/ExpedienteDetailView.vue'

export default [
  {
    path: '/expedientes',
    name: 'expedientes',
    component: ExpedienteList
  },
  {
    path: '/expediente-nuevo',
    name: 'nuevoExpediente',
    component: ExpedienteCreate
  },
  {
    path: '/expediente-editar/:idCaseFile',
    name: 'editarExpediente',
    component: ExpedienteCreateView
  },
  {
    path: '/expediente/:id',
    name: 'detalleExpediente',
    component: ExpedienteDetailView
  },
  {
    path: '/expediente/:type/:id',
    name: 'entradaExpediente',
    component: ExpedienteEntryView
  },
  {
    path: '/nueva-apelacion/:id',
    name: 'nuevaApelacion',
    component: ExpedienteCreateApelacionView
  },
  {
    path: '/nueva-resolucion-comite/:id',
    name: 'nuevaResolucionComite',
    component: ExpedienteCreateComiteView
  },
  {
    path: '/editar-resolucion/:id/:idResolution',
    name: 'editarResolucion',
    component: ExpedienteCreateComiteView
  },
  {
    path: '/nuevo-descargo/:id',
    name: 'nuevoDescargo',
    component: ExpedienteCreateDescargoView
  },
  {
    path: '/nueva-resolucion-tribunal/:id',
    name: 'nuevaResolucionTribunal',
    component: ExpedienteCreateTribunalView
  },
  {
    path: '/nueva-notificacion-comite/:id',
    name: 'nuevaNotificacionComite',
    component: ExpedienteCreateNotificationView
  }
]
